import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';

function createPrimitive(node) {
    const Node = /*#__PURE__*/ React.forwardRef((props, ref)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        return /*#__PURE__*/ jsx(Comp, {
            ...primitiveProps,
            ref: ref
        });
    });
    Node.displayName = `Primitive.${node}`;
    return Node;
}
const Primitive = {
    div: createPrimitive("div"),
    span: createPrimitive("span"),
    img: createPrimitive("img"),
    button: createPrimitive("button"),
    label: createPrimitive("label"),
    input: createPrimitive("input"),
    textarea: createPrimitive("textarea"),
    a: createPrimitive("a"),
    p: createPrimitive("p"),
    h2: createPrimitive("h2"),
    ul: createPrimitive("ul"),
    li: createPrimitive("li"),
    svg: createPrimitive("svg"),
    circle: createPrimitive("circle")
};

export { Primitive };
